<div>
    <ui-input *ngIf="formControl" [input]="input" [invalid]="invalid" [title]="title" [formControl]="formControl">
    </ui-input>

    <ui-input *ngIf="!formControl" [input]="input" [invalid]="invalid" [title]="title">
    </ui-input>

    <i class="fa" [class.fa-eye]="showPassword" [class.fa-eye-slash]="!showPassword"
        [class.invalid]="(formControl && formControl.dirty && formControl.invalid) || (!formControl && invalid)" (click)="toggleShow()"></i>
</div>
